import React from 'react';
import DataTable from 'react-data-table-component';

import { sharedTableStyles } from '../../../utils/tableStyles';
import { groupTimelineByDate } from '../../../utils/timedoctorAttendanceHelpers';

const ActivityTypeBadge = ({ type }) => {
  const isWork = type === 'work';

  return (
    <span className={`td-att-type td-att-type--${type}`}>
      <i className={`bi ${isWork ? 'bi-briefcase-fill' : 'bi-cup-hot-fill'}`} aria-hidden />
      {isWork ? 'Work' : 'Break'}
    </span>
  );
};

const activityColumns = [
  {
    name: 'TYPE',
    width: '110px',
    cell: (row) => <ActivityTypeBadge type={row.type} />
  },
  {
    name: 'START TIME',
    selector: (row) => row.startTime,
    width: '120px'
  },
  {
    name: 'END TIME',
    selector: (row) => row.endTime,
    width: '120px'
  },
  {
    name: 'DURATION',
    selector: (row) => row.duration,
    width: '100px'
  },
  {
    name: 'DETAILS',
    cell: (row) => (
      <div className="td-att-detail">
        <span className="td-att-detail__primary">{row.label}</span>
        {row.meta && row.meta !== '—' ? (
          <span className="td-att-detail__secondary">{row.meta}</span>
        ) : null}
      </div>
    )
  }
];

const TimeDoctorActivityTimeline = ({ items = [], showDateGroups = false, variant = 'table' }) => {
  if (!items.length) {
    return <div className="td-att-empty">No activity blocks for this period.</div>;
  }

  if (variant === 'table') {
    const groups = showDateGroups
      ? groupTimelineByDate(items)
      : [{ dateKey: 'all', date: null, items }];

    return (
      <div className="td-att-activity">
        {groups.map((group) => (
          <section key={group.dateKey} className="td-att-activity__group">
            {showDateGroups && group.date ? (
              <h4 className="td-att-activity__day">{group.date}</h4>
            ) : null}
            <DataTable
              columns={activityColumns}
              data={group.items}
              dense
              highlightOnHover
              striped
              noHeader={false}
              keyField="id"
              customStyles={sharedTableStyles}
            />
          </section>
        ))}
      </div>
    );
  }

  const groups = showDateGroups
    ? groupTimelineByDate(items)
    : [{ dateKey: 'all', date: null, items }];

  return (
    <div className="td-att-activity">
      {groups.map((group) => (
        <section key={group.dateKey} className="td-att-activity__group">
          {showDateGroups && group.date ? (
            <h4 className="td-att-activity__day">{group.date}</h4>
          ) : null}
          <DataTable
            columns={activityColumns}
            data={group.items}
            dense
            highlightOnHover
            striped
            noHeader
            keyField="id"
            customStyles={sharedTableStyles}
          />
        </section>
      ))}
    </div>
  );
};

export default TimeDoctorActivityTimeline;
